import React, { useState, useMemo } from 'react';
import parse, { domToReact, attributesToProps } from 'html-react-parser';

import Wrapper from './Wrapper';
import RelatedArticles from 'components/partials/RelatedArticles';
// import SubscribeSection from './SubscribeSection/index';

import stringToSlug from 'helpers/stringToSlug';
import useAllGuideArticleText from 'hooks/graphql/useAllGuideArticleText';
import useAllGuideArticleCard from 'hooks/graphql/useAllGuideArticleCard';

const ArticleDefault = ({ post }) => {
  const [anchors, setAnchors] = useState([]);

  const defaultType = post?.GuideArticleText ? true : false;
  const articleData = post;
  const relatedGuideArticleText = useAllGuideArticleText();
  const relatedGuideArticleCard = useAllGuideArticleCard();
  const curentRelatedArticles = defaultType
    ? relatedGuideArticleText
    : relatedGuideArticleCard;

  const parseOptions = useMemo(
    () => ({
      // trim: true,
      replace: (node) => {
        // node.attribs && Object.entries(node.attribs)
        //   .forEach(([key, value]) => {
        //     if (['style'].includes(key)) {
        //       delete node.attribs[key];
        //     }
        //   })

        if (['h2'].includes(node.name)) {
          if (!node || node.children.length === 0) return;

          let child = node;
          while (child.children && child !== 'text') child = child.children[0];
          const label = domToReact(node.children);

          const slug = stringToSlug(child.data);

          setAnchors((store) => [...store, { link: slug, lable: child.data }]);

          return (
            <>
              <span id={slug}></span>
              <h2 {...attributesToProps(node.attribs)}>{label}</h2>
            </>
          );
        }

        if (['h3'].includes(node.name)) {
          if (!node || node.children.length === 0) return;

          let child = node;
          while (child.children && child !== 'text') child = child.children[0];
          const label = domToReact(node.children);

          const slug = stringToSlug(child.data);

          setAnchors((store) => [...store, { link: slug, lable: child.data }]);

          return (
            <>
              <span id={slug}></span>
              <h3 {...attributesToProps(node.attribs)}>{label}</h3>
            </>
          );
        }

        return node;
      },
    }),
    [setAnchors],
  );

  const currentContent = useMemo(
    () =>
      Array.isArray(articleData?.GuideArticleCard?.articlePostContentCards)
        ? articleData?.GuideArticleCard?.articlePostContentCards.map((item) =>
            parse(item.articlePostItemCard || '', parseOptions),
          )
        : parse(articleData?.content || '', parseOptions),
    [articleData?.GuideArticleCard, articleData?.content, parseOptions],
  );

  return (
    <>
      <Wrapper
        spyNavData={anchors}
        content={currentContent}
        data={articleData}
        defaultType={defaultType}
      />
      <RelatedArticles
        currntPostId={post.id}
        data={curentRelatedArticles}
        bgColor={!defaultType ? 'bg-mischka' : 'bg-merino'}
      />
      {/* <SubscribeSection /> */}
    </>
  );
};

export default ArticleDefault;
